import { render, staticRenderFns } from "./MaterialTransferRegion.vue?vue&type=template&id=a0da3b52&"
import script from "./MaterialTransferRegion.vue?vue&type=script&lang=js&"
export * from "./MaterialTransferRegion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports